import React from 'react';

interface TruncaterProps {
    text: string;
    length: number;
    as?: keyof JSX.IntrinsicElements; // p, a, div, span gibi HTML öğeleri için
    className?: string; // Özel class adı
}

const Truncater: React.FC<TruncaterProps> = ({ text, length, as, className }) => {
    if (text.length <= length) {
        return as ? React.createElement(as, { className }, text) : <>{text}</>;
    }

    const truncatedText = text.slice(0, length) + '...';

    return as ? React.createElement(as, { className }, truncatedText) : <>{truncatedText}</>;
};

export default Truncater;
